export default "__VITE_ASSET__b21ae729__"